import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    project: {},
    projects: [],
    projectListWithDetails: [],
    foundProjects: [],
    projectChecklists: [],
    partners: [],
    leadPartner: {},
    lastPaymentDate: null,
    summaryChecklist: process.env.REACT_APP_STEP1_SUMMARY_CHECKLIST,
    step1Eligibility: process.env.REACT_APP_STEP1_ELIGIBILITY_CHECKLIST,
    step1Quality: process.env.REACT_APP_STEP1_QUALITY_CHECKLIST,
    step1JSOpinion: process.env.REACT_APP_STEP1_JS_OPINION,
    step2SummaryCheckList: process.env.REACT_APP_STEP2_SUMMARY_CHECKLIST,
    step2Eligibility: process.env.REACT_APP_STEP2_ELIGIBILITY_CHECKLIST,
    step2Quality: process.env.REACT_APP_STEP2_QUALITY_CHECKLIST,
    step2JSOpinion: process.env.REACT_APP_STEP2_JS_OPINION,
    step2StateAid1: process.env.REACT_APP_STEP2_STATE_AID_1,
    step2StateAid2: process.env.REACT_APP_STEP2_STATE_AID_2,
    oneStepEligibility: process.env.REACT_APP_ONE_STEP_ELIGIBILITY_CHECKLIST,
    capCallSummaryCheckList: process.env.REACT_APP_CAPCALL_SUMMARY_CHECKLIST,
    capCallEligibility: process.env.REACT_APP_CAPCALL_ELIGIBILITY_CHECKLIST,
    capCallQuality: process.env.REACT_APP_CAPCALL_QUALITY_CHECKLIST,
    capCallJSOpinion: process.env.REACT_APP_CAPCALL_JS_OPINION,
    capCallTechnicalRequirements: process.env.REACT_APP_CAPCALL_TECHNICAL_REQUIREMENTS,
    capCallRejectionReasons: process.env.REACT_APP_CAPCALL_REJECTION_REASONS,
    // Monitoring Committee deciding on the capitalisation initiatives (update for the next cap call)
    capCallCommission: {
        date: '6 October 2026',
        location: 'Leeuwarden, Netherlands',
        technicalRequirementsDeadline: '3 December 2026',
        webinarDate: '19 November 2026',
    },
    dataToExport: [],
    letter: {},
    mapImage: "",
    mapCenter: [6.959974, 50.938361],
    markers: {},
    jsOfficers: [
        { key: 'eva', value: ['Eva Clymans', 'eva@nweurope.eu'], text: 'Eva Clymans' },
        { key: 'inge', value: ['Inge Keymeulen', 'inge@nweurope.eu'], text: 'Inge Keymeulen' },
        // { key: 'irma', value: ['Irma Botic', 'irma@nweurope.eu'], text: 'Irma Botic' },
        { key: 'luka', value: ['Luka Messmer', 'luka@nweurope.eu'], text: 'Luka Messmer' },
        { key: 'matthew', value: ['Matthew Thompson', 'matthew@nweurope.eu'], text: 'Matthew Thompson' },
        // { key: 'olivier', value: ['Olivier Rohas', 'olivier@nweurope.eu'], text: 'Olivier Rohas' },
        { key: 'rebecca', value: ['Rebecca Grossberg', 'rebecca@nweurope.eu'], text: 'Rebecca Grossberg' },
        { key: 'sarine', value: ['Sarine Barsoumian', 'sarine@nweurope.eu'], text: 'Sarine Barsoumian' },
        { key: 'vincent', value: ['Vincent Hagnere', 'vincent@nweurope.eu'], text: 'Vincent Hagnere' },
        { key: 'maelle', value: ['Maëlle Lebon', 'maelle@nweurope.eu'], text: 'Maëlle Lebon' },
        { key: 'nicolas', value: ['Nicolas MEULEBROUCK', 'nicolas@nweurope.eu'], text: 'Nicolas MEULEBROUCK' },
    ],
    contactPoints: [
        // { key: 'shanna', value: ['Shanna Vanblaere', 'shanna.vanblaere@vlaio.be'], text: 'Shanna Vanblaere' },
        { key: 'loris', value: ['Loris Sedrani', 'loris.sedrani@vlaio.be'], text: 'Loris Sedrani' },
        { key: 'celine', value: ['Céline Manac’h', 'cmanach@sprb.brussels' ], text: 'Céline Manac’h' },
        { key: 'thierry', value: ['Thierry Noville', 't.noville@wbi.be' ], text: 'Thierry Noville' },
        { key: 'lorraine', value: ['Lorraine Brindel-Schild', 'lorraine.brindel-schild@sgdsued.rlp.de' ], text: 'Lorraine Brindel-Schild' },
        { key: 'nora', value: ['Nora Crossey', 'nora.crossey@sgdsued.rlp.de' ], text: 'Nora Crossey' },
        { key: 'ann-sophie', value: ['Ann-Sophie SEEMANN', 'ann-sophie.seemann@sgdsued.rlp.de' ], text: 'Ann-Sophie SEEMANN' },
        { key: 'alexandre', value: ['Alexandre Tournakis', 'alexandre.tournakis@hautsdefrance.fr' ], text: 'Alexandre Tournakis' },
        { key: 'valentine', value: ['Valentine Labouheure', 'valentine.labouheure@grandest.fr' ], text: 'Valentine Labouheure' },
        { key: 'sarah', value: ['Sarah Davoren', 'sdavoren@southernassembly.ie' ], text: 'Sarah Davoren' },
        { key: 'nicole', value: ['Nicole Skirde-Vural', 'cpinterreg.europenwe@mat.etat.lu' ], text: 'Nicole Skirde-Vural' },
        { key: 'ge', value: ['Gé Huismans', 'ge.huismans@rvo.nl' ], text: 'Gé Huismans' },
        { key: 'esther', value: ['Esther Veenendaal', 'esther.veenendaal@rvo.nl' ], text: 'Esther Veenendaal' },
        { key: 'sebastien', value: ['Sébastien Rieben', 'sebastien.rieben@are.admin.ch' ], text: 'Sébastien Rieben' },
        // { key: 'mayuri', value: ['Mayuri Patel', 'mayuri.patel@levellingup.gov.uk' ], text: 'Mayuri Patel' },
    ],
    letterContactPoints: [
        // { pays: 'Belgium', codePays: 'BE2', contact: 'Matthias Verhegge', email: 'matthias.verhegge@vlaio.be' },
        // { pays: 'Belgium', codePays: 'BE2', contact: 'Shanna Vanblaere', email: 'shanna.vanblaere@vlaio.be' },
        { pays: 'Belgium', codePays: 'BE2', contact: 'Loris Sedrani', email: 'loris.sedrani@vlaio.be' },
        { pays: 'Belgium', codePays: 'BE1', contact: 'Céline Manac’h', email: 'cmanach@sprb.brussels' },
        { pays: 'Belgium', codePays: 'BE3', contact: 'Thierry Noville', email: 't.noville@wbi.be' },
        { pays: 'Germany', codePays: 'DE', contact: 'Lorraine Brindel-Schild', email: 'Lorraine.Brindel-Schild@sgdsued.rlp.de' },
        { pays: 'Germany', codePays: 'DE', contact: 'Nora Crossey', email: 'Nora.Crossey@sgdsued.rlp.de' },
        { pays: 'Germany', codePays: 'DE', contact: 'Ann-Sophie SEEMANN', email: 'ann-sophie.seemann@sgdsued.rlp.de' },
        { pays: 'France', codePays: 'FR', contact: 'Alexandre Tournakis', email: 'alexandre.tournakis@hautsdefrance.fr' },
        { pays: 'France', codePays: 'FR', contact: 'Valentine Labouheure', email: 'valentine.labouheure@grandest.fr' },
        { pays: 'Ireland', codePays: 'IE', contact: 'Sarah Davoren', email: 'sdavoren@southernassembly.ie' },
        { pays: 'Luxembourg', codePays: 'LU', contact: 'Nicole Skirde-Vural', email: 'CpInterreg.EuropeNwe@mat.etat.lu' },
        { pays: 'The Netherlands', codePays: 'NL', contact: 'Gé Huismans', email: 'ge.huismans@rvo.nl' },
        { pays: 'The Netherlands', codePays: 'NL', contact: 'Esther Veenendaal', email: 'esther.veenendaal@rvo.nl' },
        { pays: 'Switzerland', codePays: 'CH', contact: 'Sébastien Rieben', email: 'sebastien.rieben@are.admin.ch' },
        // { pays: 'United Kingdom', codePays: 'UK', contact: 'Mayuri Patel', email: 'Mayuri.Patel@levellingup.gov.uk' }
    ],
    defaultAdditionalComment: [
        '- The result indicators presented in the application form must be revised. The following should be considered:\n\
<span className="text-accent">Result indicator: Joint strategies and action plans taken up by organisations (RCR 79)</span>\n\n\
- The partnership is reminded that the result indicator ‘RCR 79 Joint strategies and action plans taken up by organisations’ relates to the output indicator ‘RCO83 Strategies and action plans jointly developed‘. As such, project strategies and action plans must first be jointly developed, before they are taken up by project partners or organisations external to the project.\n\n\
- The indicator ‘RCR 79 Joint strategies and action plans taken up by organisations’ counts the number of joint strategies and action plans (and not individual actions) being adopted and starting to get implemented by organisations during the project as a result of uptake/upscale activities.\n\n\
- The target value for the indicator ‘RCR 79 Joint strategies and action plans taken up by organisations’ should be realistic and relate only to strategies and action plans being practically adopted and starting to get implemented during the project lifetime.\n\n\
Result indicator: Solutions taken up or up-scaled by organisations (RCR 104)\n\n\
- The partnership is reminded that the result indicator ‘RCR 104 Solutions taken up or up-scaled by organisations’ relates to the output indicator ‘RCO116 Jointly developed solutions‘. Thus, project solutions must first be jointly developed before they are taken up by project partners or organisations external to the project.\n\n\
- The target value for the indicator ‘RCR 104 Solutions taken up or up-scaled by organisations’ should be realistic and relate only to solutions tangibly adopted and implemented during the project.\n\n\
Result indicator: Completion of joint training schemes (RCR 81)\n\n\
- Joint training scheme(s) envisaged by the project need to be jointly developed and/or delivered by the partners of at least two countries participating in the project.\n\n\
- The total number of participants must be realistic and clearly linked to the training scheme delivered by the project partners within the thematic project context.\n\n\
',
        '- Budget: While defining their budget, project partners should be as specific as possible and provide a short and clear description for each item listed.\n\
- For staff costs, the role and projected FTE input in the project of the staff member concerned has to be included in the description for expenditure claiming options (simplified cost option or real costs).\n\
- Investments contribute to the delivery of outputs and results that will last beyond project’s lifetime and can include costs under all cost categories of the Programme. Relating cost items must be linked to the specific investment concerned (proper tick box to be ticked).\n\n\
- Partnership agreement: to allow for a smooth start of the project after approval, project partners should review the partnership agreement template and agree on a draft before step 2 submission. If possible, project applicants are strongly recommended to submit a signed version of the partnership agreement (PDF format) along with the step 2 application form in Jems (Section Application Annexes). If not possible, a reviewed and provisionally agreed version of the partnership agreement should be submitted by the step 2 deadline.\n\n\
- Private partners from France, Germany, Ireland, Luxembourg, Belgium (Wallonia and Brussels-Capital): all necessary documents regarding solvency of private partners should be uploaded in Jems (Section Application Annexes).\n\n\
- Other supporting documents: Projects have the possibility to upload a one-page document to illustrate the content described in the application form. The document can only include visual elements (such as illustrations, infographics, graphs) and the format must be a single A4 page in PDF format. Anything beyond what is described above will be disregarded by the Programme.\n\n\
For further information about all points listed above, please see the NWE Programme Manual available on the NWE Programme website (https://www.nweurope.eu/reference-documents).'
    ],
    commissionDates: [
        {fr:'22-23 Mars 2023', en: '22-23 March 2023'},
        {fr:'21-22 Novembre 2023', en: '21-22 November 2023'},
        {fr:'21-22 Novembre 2023', en: '21-22 November 2023'},
        {fr:'10-11 Décembre 2024', en: '10-11 December 2024'},
    ],
    selectedDate: new Date().getTime(),
    oneStepCall: [3],
    isOneStepCall: false,
}

export const projectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        setProject: (state, action) => {
            state.project = (action.payload);
        },
        addProjectChecklist: (state, action) => {
            state.projectChecklists.push(action.payload);
        },
        addProjectWithDetail: (state, action) => {
            state.projectListWithDetails.push(action.payload);
            console.log('Project With Detail Added');
        },
        setProjects: (state, action) => {
            state.projects = (action.payload);
        },
        resetProject: (state, action) => {
            state.project = {};
            state.projectChecklists = [];
            state.partners = [];
            state.leadPartner = {};
            state.letter = {};
            state.mapImage = "";
            state.markers = {};

        },
        resetProjectListWithDetail: (state, action) => {
            state.projectListWithDetails = [];

        },
        setPartners: (state, action) => {
            state.partners = (action.payload);
        },
        setLeadPartner: (state, action) => {
            state.leadPartner = (action.payload);
        },
        setDataToExport: (state, action) => {
            state.dataToExport = (action.payload);
        },
        setLetter: (state, action) => {
            state.letter = (action.payload);
        },
        setMapImage: (state, action) => {
            state.mapImage = (action.payload);
        },
        setMapCenter: (state, action) => {
            state.mapCenter = (action.payload);
        },
        setMarkers: (state, action) => {
            state.markers = (action.payload);
        },
        setLetterStep2DataProjectRelevance: (state, action) => {
            state.letter.step2Data.projectRelevance = (action.payload);
        },
        setLetterStep2DataPartnershipCooperation: (state, action) => {
            state.letter.step2Data.partnershipCooperation = (action.payload);
        },
        setLetterStep2DataProjectIntervention: (state, action) => {
            state.letter.step2Data.projectIntervention = (action.payload);
        },
        setLetterStep2DataWorkPlan: (state, action) => {
            state.letter.step2Data.workPlan = (action.payload);
        },
        setLetterStep2DataCommunication: (state, action) => {
            state.letter.step2Data.communication = (action.payload);
        },
        setLetterStep2DataBudget: (state, action) => {
            state.letter.step2Data.budget = (action.payload);
        },
        setLetterStep2DataAdditional: (state, action) => {
            state.letter.step2Data.additional = (action.payload);
        },
        setClosureLetterInvestmentData: (state, action) => {
            state.letter.closureInvestmentData = (action.payload);
        },
        setLetterCapCallData: (state, action) => {
            state.letter.capCallData = { ...state.letter.capCallData, [action.payload.key]: action.payload.value };
        },
        setLetterJsOfficer: (state, action) => {
            state.letter.jsOfficer = (action.payload);
        },
        setLetterContactPoint: (state, action) => {
            state.letter.contactPoint = (action.payload);
        },
        setLetterStep1DataProjectNeed: (state, action) => {
            state.letter.step1Data.projectNeed = (action.payload);
        },
        setLetterStep1DataObjectiveContribution: (state, action) => {
            state.letter.step1Data.objectiveContribution = (action.payload);
        },
        setLetterStep1DataAddedValueOfProgrammApproch: (state, action) => {
            state.letter.step1Data.addedValueOfProgrammApproch = (action.payload);
        },
        setLetterStep1DataPartnershipRelevance: (state, action) => {
            state.letter.step1Data.partnershipRelevance = (action.payload);
        },
        setLetterStep1DataAdditional: (state, action) => {
            state.letter.step1Data.additional = (action.payload);
        },
        setLetterSubsidyContractDate: (state, action) => {
            state.letter.subsidyContractDate = action.payload;
        },
        setSelectedDate: (state, action) => {
            state.selectedDate = action.payload;
        },
        setOneStepCall: (state, action) => {
            if (state.oneStepCall.includes(action.payload)) {
                state.isOneStepCall = true;
            } else {
                state.isOneStepCall = false;
            }
        },
        setLastPaymentDate: (state, action) => {
            state.lastPaymentDate = action.payload;
        }
    }
})

export const {
    setProject,
    setProjects,
    addProjectChecklist,
    resetProject,
    setPartners,
    setLeadPartner,
    addProjectWithDetail,
    resetProjectListWithDetail,
    setDataToExport,
    setLetter,
    setMapImage,
    setMapCenter,
    setMarkers,
    setLetterStep2DataProjectRelevance,
    setLetterStep2DataPartnershipCooperation,
    setLetterStep2DataProjectIntervention,
    setLetterStep2DataWorkPlan,
    setLetterStep2DataCommunication,
    setLetterStep2DataBudget,
    setLetterStep2DataAdditional,
    setClosureLetterInvestmentData,
    setLetterCapCallData,
    setLetterJsOfficer,
    setLetterContactPoint,
    setLetterStep1DataProjectNeed,
    setLetterStep1DataObjectiveContribution,
    setLetterStep1DataAddedValueOfProgrammApproch,
    setLetterStep1DataPartnershipRelevance,
    setLetterStep1DataAdditional,
    setLetterSubsidyContractDate,
    setSelectedDate,
    setOneStepCall,
    setLastPaymentDate
} = projectSlice.actions;
export default projectSlice.reducer
